import React from 'react';
import cn from 'classnames';
import { lazyGettext } from 'translations';
import moment from 'moment-timezone';

import { ActivityData } from '../index';
import IconButton, { ButtonType } from '../IconButton';
import { formatNumber } from '../../util';

import styles from './styles.module.scss';
import LazyString from 'lazy-string';

interface ActivityType {
  [key: string]: {
    translate: LazyString;
    icon: ButtonType;
  };
}

const ACTIVITY_TYPE: ActivityType = {
  'purchase': {
    'translate': lazyGettext('적립'),
    'icon': ButtonType.Plus,
  },
  'usage_group': {
    'translate': lazyGettext('사용'),
    'icon': ButtonType.Minus,
  },
  'adjustment': {
    'translate': lazyGettext('변경'),
    'icon': ButtonType.Change,
  },
  'expiration': {
    'translate': lazyGettext('만료'),
    'icon': ButtonType.Minus,
  },
  'purchase_revocation': {
    'translate': lazyGettext('적립 취소'),
    'icon': ButtonType.Minus,
  },
  'usage_revocation': {
    'translate': lazyGettext('사용 취소'),
    'icon': ButtonType.Plus,
  },
  'migration': {
    'translate': lazyGettext('변경'),
    'icon': ButtonType.Change,
  },
};

interface Props {
  activity: ActivityData;
}

const ActivityItem: React.FC<Props> = props => {
  const { activity } = props;

  const { translate: type, icon } = ACTIVITY_TYPE[activity.type];
  const formattedPoint = formatNumber(activity.points);
  const point: string = activity.points >= 0 ? `+${formattedPoint}` : formattedPoint;
  const typeClassName: string = activity.points >= 0 ? styles.plus : styles.minus;
  const createdAt: string = moment(activity.createdAt).format('YYYY/MM/DD');

  return (
        <div className={styles.activityItem}>
            <IconButton type={icon} className={styles.activityIcon} />
            <div className={styles.activityDescription}>
                <p className={styles.activityType}>{type.toString()}</p>
                <p className={styles.createdAt}>{createdAt}</p>
            </div>
            <div className={cn(styles.activityPoint, typeClassName)}>
                <p>{point} <span>P</span></p>
            </div>
        </div>
  );
};

export default ActivityItem;
